import { render } from "./FetcherView.vue?vue&type=template&id=44566843"
import script from "./FetcherView.vue?vue&type=script&lang=js"
export * from "./FetcherView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__